module.exports = __webpack_public_path__ + "img/Group 124@2x.eac5c9b0.png";